/* ============
 * Adjustment Transformer
 * ============
 */

import Transformer from './transformer';
import productTrans from './product';

export default class AdjustmentProductTransformer extends Transformer {

  static fetch(adjustment) {
    return {
      id: adjustment.id,
      qty: adjustment.qty,
      batchId: adjustment.batch_id,
      product_id: adjustment.product_id,
      adjustment_id: adjustment.adjustment_id,
      exciseAdditionalCode: adjustment.excise_additional_code,
      product: adjustment.product !== undefined ? productTrans.fetch(adjustment.product) : [],
    };
  }

  static send(adjustment) {
    const productId = typeof adjustment.productId === 'object' ? adjustment.productId.id : adjustment.productId;
    return {
      qty: adjustment.qty,
      batch_id: adjustment.batchId,
      id: productId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/adjustmentProduct.js